export default "__VITE_ASSET__CN_o4yU___"